import {
    LoginRequest,
    LoginRequestFailure,
    LoginRequestSuccess,
    LoginResponse,
    GoogleLoginRequest,
    GoogleLoginRequestFailure,
    GoogleLoginRequestSuccess,
    MFASetupRequest,
    MFASetupRequestSuccess,
    MFASetupRequestFailure,
    MFAVerifyRequest,
    MFAVerifyRequestSuccess,
    MFAVerifyRequestFailure,
    LogoutRequest,
    LogoutRequestFailure,
    MFASetupVerifyRequestSuccess,
    MFASetupVerifyRequestFailure,
    MFASetupVerifyRequest,
    ResetmfaState,
    ShowAddMFAModal,
} from 'redux/types/authActionModel';
import * as actionTypes from '../actionTypes';
import { FailurePayload } from '../types';

export const loginRequest = (payload: { email: string; password: string }): LoginRequest => ({
    type: actionTypes.LOGIN_REQUEST,
    payload,
});

export const loginRequestSuccess = (payload: LoginResponse): LoginRequestSuccess => ({
    type: actionTypes.LOGIN_REQUEST_SUCCESS,
    payload,
});

export const loginRequestFailure = (payload: FailurePayload): LoginRequestFailure => ({
    type: actionTypes.LOGIN_REQUEST_FAILURE,
    payload,
});

export const googleLoginRequest = (payload: { code: string }): GoogleLoginRequest => ({
    type: actionTypes.GOOGLE_LOGIN_REQUEST,
    payload,
});

export const googleLoginRequestSuccess = (payload: LoginResponse): GoogleLoginRequestSuccess => ({
    type: actionTypes.GOOGLE_LOGIN_REQUEST_SUCCESS,
    payload,
});

export const googleLoginRequestFailure = (payload: FailurePayload): GoogleLoginRequestFailure => ({
    type: actionTypes.GOOGLE_LOGIN_REQUEST_FAILURE,
    payload,
});

export const mfaSetupRequest = (): MFASetupRequest => ({
    type: actionTypes.MFA_SETUP_REQUEST,
});

export const mfaSetupRequestSuccess = (payload: { qrCode: string; secret: string }): MFASetupRequestSuccess => ({
    type: actionTypes.MFA_SETUP_REQUEST_SUCCESS,
    payload,
});

export const mfaSetupRequestFailure = (payload: FailurePayload): MFASetupRequestFailure => ({
    type: actionTypes.MFA_SETUP_REQUEST_FAILURE,
    payload,
});

export const mfaVerifyRequest = (payload: { code: string }): MFAVerifyRequest => ({
    type: actionTypes.MFA_VERIFY_REQUEST,
    payload,
});

export const mfaVerifyRequestSuccess = (payload: LoginResponse): MFAVerifyRequestSuccess => ({
    type: actionTypes.MFA_VERIFY_REQUEST_SUCCESS,
    payload,
});

export const mfaVerifyRequestFailure = (payload: FailurePayload): MFAVerifyRequestFailure => ({
    type: actionTypes.MFA_VERIFY_REQUEST_FAILURE,
    payload,
});

export const logoutRequest = (): LogoutRequest => ({
    type: actionTypes.LOGOUT_REQUEST,
});

export const logoutRequestFailure = (payload: FailurePayload): LogoutRequestFailure => ({
    type: actionTypes.LOGOUT_REQUEST_FAILURE,
    payload,
});
export const mfaSetupVerifyRequest = (payload: { code: string,secret:string|null|undefined,mfa_name:string }):MFASetupVerifyRequest => ({
    type: actionTypes.MFA_SETUP_VERIFY_REQUEST,
    payload,
});

export const mfaSetupVerifyRequestSuccess = (payload: LoginResponse): MFASetupVerifyRequestSuccess => ({
    type: actionTypes.MFA_SETUP_VERIFY_REQUEST_SUCCESS,
    payload,
});

export const mfaSetupVerifyRequestFailure = (payload: FailurePayload): MFASetupVerifyRequestFailure => ({
    type: actionTypes.MFA_SETUP_VERIFY_REQUEST_FAILURE,
    payload,
});
export const resetMfaState = ():ResetmfaState => ({
    type: actionTypes.RESET_MFA_STATE,
  });
export const showAddMFAModal=(payload:boolean):ShowAddMFAModal=>({
    type: actionTypes.SHOW_ADD_MFA_MODAL,
    payload
})
